/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * 
 * @export
 * @interface NaturalPersonDto
 */
export interface NaturalPersonDto {
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDto
     */
    civilityId: string;
    /**
     * 
     * @type {Date}
     * @memberof NaturalPersonDto
     */
    birthDate: Date;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDto
     */
    firstName: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof NaturalPersonDto
     */
    address: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDto
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDto
     */
    birthName?: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDto
     */
    birthCountryId: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDto
     */
    taxResidenceCountryId: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDto
     */
    nationalityId: string;
    /**
     * 
     * @type {boolean}
     * @memberof NaturalPersonDto
     */
    isPPE: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NaturalPersonDto
     */
    isFPE: boolean;
    /**
     * 
     * @type {string}
     * @memberof NaturalPersonDto
     */
    companyRole?: string;
}

/**
 * Check if a given object implements the NaturalPersonDto interface.
 */
export function instanceOfNaturalPersonDto(value: object): value is NaturalPersonDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('civilityId' in value) || value['civilityId'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('birthCountryId' in value) || value['birthCountryId'] === undefined) return false;
    if (!('taxResidenceCountryId' in value) || value['taxResidenceCountryId'] === undefined) return false;
    if (!('nationalityId' in value) || value['nationalityId'] === undefined) return false;
    if (!('isPPE' in value) || value['isPPE'] === undefined) return false;
    if (!('isFPE' in value) || value['isFPE'] === undefined) return false;
    return true;
}

export function NaturalPersonDtoFromJSON(json: any): NaturalPersonDto {
    return NaturalPersonDtoFromJSONTyped(json, false);
}

export function NaturalPersonDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NaturalPersonDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'id': json['id'] == null ? undefined : json['id'],
        'civilityId': json['civilityId'],
        'birthDate': (new Date(json['birthDate'])),
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'address': AddressDtoFromJSON(json['address']),
        'phone': json['phone'],
        'email': json['email'],
        'birthName': json['birthName'] == null ? undefined : json['birthName'],
        'birthCountryId': json['birthCountryId'],
        'taxResidenceCountryId': json['taxResidenceCountryId'],
        'nationalityId': json['nationalityId'],
        'isPPE': json['isPPE'],
        'isFPE': json['isFPE'],
        'companyRole': json['companyRole'] == null ? undefined : json['companyRole'],
    };
}

export function NaturalPersonDtoToJSON(json: any): NaturalPersonDto {
    return NaturalPersonDtoToJSONTyped(json, false);
}

export function NaturalPersonDtoToJSONTyped(value?: NaturalPersonDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'id': value['id'],
        'civilityId': value['civilityId'],
        'birthDate': ((value['birthDate']).toISOString()),
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'address': AddressDtoToJSON(value['address']),
        'phone': value['phone'],
        'email': value['email'],
        'birthName': value['birthName'],
        'birthCountryId': value['birthCountryId'],
        'taxResidenceCountryId': value['taxResidenceCountryId'],
        'nationalityId': value['nationalityId'],
        'isPPE': value['isPPE'],
        'isFPE': value['isFPE'],
        'companyRole': value['companyRole'],
    };
}

